module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAAAGAQMAAAAPEKlGAAAAA1BMVEUZgvbp5gjFAAAAC0lEQVQI12OgAQAAAFQAAR5BrJQAAAAASUVORK5CYII="